var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraphDownArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 10.5V6C18 5.55 17.7 5.25 17.25 5.25C16.8 5.25 16.5 5.55 16.5 6V8.7L10.65 2.85C10.35 2.55 9.9 2.55 9.6 2.85L6.375 6.075L1.275 0.975C1.125 0.825 0.975 0.75 0.75 0.75C0.525 0.75 0.375 0.825 0.225 0.975C-0.075 1.275 -0.075 1.725 0.225 2.025L5.85 7.65C6.15 7.95 6.6 7.95 6.9 7.65L10.125 4.425L15.45 9.75H12.75C12.3 9.75 12 10.05 12 10.5C12 10.95 12.3 11.25 12.75 11.25H17.25C17.325 11.25 17.475 11.25 17.55 11.175C17.7 11.1 17.85 10.95 17.925 10.8C18 10.725 18 10.575 18 10.5Z",
    fill: "#EF5350"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphDownArrow);
export default __webpack_public_path__ + "static/media/GraphDownArrow.413b8ac2.svg";
export { ForwardRef as ReactComponent };